class MediaQuery {
  /**
   * Gets the media queries for all viewports (xsmall, small, medium, large, and xlarge)
   */
  static get queries() {
    return {
      xsmall: '(max-width: 419px)',
      small: '(min-width: 420px) and (max-width: 599px)',
      medium: '(min-width: 600px) and (max-width: 959px)',
      large: '(min-width: 960px) and (max-width: 1499px)',
      xlarge: 'only screen and (min-width: 1500px)',
    };
  }

  /**
   * Gets the current browser media query of the breakpoint
   * @returns {string|null} - The media query of the breakpoint, or `null` if the breakpoint doesn't exist.
   */
  static get current() {
    const queries = MediaQuery.queries;

    for (let key of Object.keys(queries)) {
      if (matchMedia(queries[key]).matches) {
        return key;
      }
    }
    return null;
  }

  /**
   * Checks if the screen is at least as wide as a breakpoint.
   * @function
   * @param {String} breakpoint - Name of the breakpoint to check.
   * @returns {Boolean} `true` if the breakpoint matches, `false` if it's smaller.
   */
  static atLeast(breakpoint) {
    const queries = {
      xsmall: 'only screen and (min-width: 320px)',
      small: 'only screen and (min-width: 420px)',
      medium: 'only screen and (min-width: 600px)',
      large: 'only screen and (min-width: 960px)',
      xlarge: 'only screen and (min-width: 1500px)',
    };
    const mediaQueryString = queries[breakpoint];

    if (mediaQueryString) {
      return matchMedia(mediaQueryString).matches;
    }

    return false;
  }
}

export default MediaQuery;
